<template>
  <div class="cm-instancias-odt">
    <v-container fluid>
      <v-row dense>
        <v-col cols="12">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Filtros
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row dense>
                  <v-col cols="12" md="4" sm="6">
                    <v-text-field v-model="nuevoIdInstancia" label="Agregar ID Instancia" type="number" min="1"
                      clearable hide-details @keydown.enter.prevent="agregarIdInstancia">
                      <template v-slot:append>
                        <v-btn x-small color="primary" @click="agregarIdInstancia">
                          Agregar
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" md="8" sm="6" class="d-flex align-center flex-wrap">
                    <v-chip v-for="idInstancia in filtros.IdsIntancias" :key="`id-instancia-${idInstancia}`" small close
                      class="ma-1" @click:close="eliminarIdInstancia(idInstancia)">
                      {{ idInstancia }}
                    </v-chip>
                  </v-col>

                  <v-col cols="12" md="4" sm="6">
                    <VueCtkDateTimePicker v-model="filtros.FechaDeArranqueInicio" label="Fecha De Arranque Inicio" format="YYYY-MM-DD HH:mm"
                      formatted="YYYY-MM-DD HH:mm" noHeader overlay buttonNowTranslation="Ahora" />
                  </v-col>

                  <v-col cols="12" md="4" sm="6">
                    <VueCtkDateTimePicker v-model="filtros.FechaDeArranqueFin" :min-date="filtros.FechaDeArranqueInicio" label="Fecha De Arranque Fin"
                      format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm" noHeader overlay
                      buttonNowTranslation="Ahora" />
                  </v-col>
                  <v-col cols="12" class="d-flex justify-end">
                    <v-btn color="purple" @click="InformadorInstanciaODT" :loading="InformadorInstanciasLoading">
                      Buscar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid>
      <v-row dense>
        <v-col v-for="(instancia, indexInstancia) in data"
          :key="pick(instancia, ['IdMaquinaIns', 'idMaquinaIns'], `inst-${indexInstancia}`)" cols="12" sm="6" md="3">
          <v-card outlined class="instancia-card" :class="{ 'instancia-card--active': selectedInstancia === instancia }"
            @click="seleccionarInstancia(instancia)">
            <v-card-title class="text-subtitle-1 font-weight-bold">
              {{ pick(instancia, ["NombreMaquina", "nombreMaquina"], "Sin nombre") }}
            </v-card-title>
            <v-card-subtitle>
              Id Instancia: {{ pick(instancia, ["IdMaquinaIns", "idMaquinaIns"], "-") }}
            </v-card-subtitle>
            <v-card-subtitle class="pt-0">
              ODTs: {{ countOdtByInstancia(instancia) }}
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid v-if="selectedInstancia">
      <v-row dense>
        <v-col cols="12" md="3">
          <v-card outlined class="mb-3">
            <v-card-title class="text-subtitle-1 font-weight-bold">
              ODTs
            </v-card-title>
            <v-divider />
            <v-card-text class="pb-0">
              <v-text-field v-model="odtSearch" label="Buscar ODT por clave" clearable dense hide-details />
            </v-card-text>
            <v-list dense nav>
              <v-list-item v-for="(odt, indexOdt) in odtsFiltradas"
                :key="pick(odt, ['IdTrabajoOrden', 'idTrabajoOrden'], `odt-${indexOdt}`)" class="list-item-clickable"
                :class="{ 'list-item-active': selectedODT === odt }" @click="seleccionarODT(odt)">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ pick(odt, ["Clave", "clave"], "Sin clave") }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    ID {{ pick(odt, ["IdTrabajoOrden", "idTrabajoOrden"], "-") }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-card-text v-if="!odtsSeleccionadas.length" class="grey--text text--darken-1">
              Sin ODTs para esta instancia.
            </v-card-text>
            <v-card-text v-else-if="!odtsFiltradas.length" class="grey--text text--darken-1">
              Sin coincidencias para la clave buscada.
            </v-card-text>
          </v-card>

          <v-card outlined>
            <v-card-title class="text-subtitle-1 font-weight-bold">
              Operaciones
            </v-card-title>
            <v-divider />
            <v-list dense nav>
              <v-list-item v-for="(operacion, indexOperacion) in operacionesSeleccionadas"
                :key="pick(operacion, ['IdOperacion', 'idOperacion'], `op-${indexOperacion}`)"
                class="list-item-clickable" :class="{ 'list-item-active': selectedOperacion === operacion }"
                @click="seleccionarOperacion(operacion)">
                <v-list-item-content>
                  <v-list-item-title>
                    Operación {{ pick(operacion, ["IdOperacion", "idOperacion"], "-") }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Paso {{ pick(operacion, ["IdPaso", "idPaso"], "-") }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-card-text v-if="!operacionesSeleccionadas.length" class="grey--text text--darken-1">
              {{ selectedODT ? "Sin operaciones para esta ODT." : "Selecciona una ODT para ver sus operaciones." }}
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="9">
          <v-card outlined v-if="selectedOperacion">
            <v-card-title class="d-flex align-center">
              <span class="text-h6">Detalle de operación</span>
              <v-spacer />
              <v-chip small color="primary" text-color="white">
                ODT {{ pick(selectedODT, ["IdTrabajoOrden", "idTrabajoOrden"], "-") }}
              </v-chip>
            </v-card-title>

            <v-card-text>
              <v-row dense>
                <v-col v-for="item in resumenOperacion" :key="item.label" cols="12" sm="6" md="4">
                  <div class="text-caption grey--text text--darken-1">{{ item.label }}</div>
                  <div class="font-weight-medium">{{ item.value }}</div>
                </v-col>
              </v-row>

              <v-tabs v-model="detalleTab" class="mt-3" grow>
                <v-tab>Operaciones Reales</v-tab>
                <v-tab>Paros</v-tab>
                <v-tab>No OK</v-tab>
              </v-tabs>

              <v-tabs-items v-model="detalleTab">
                <v-tab-item>
                  <v-data-table :headers="headersOperacionesReales" :items="operacionesRealesRows" dense
                    class="elevation-1 mt-3">
                    <template v-slot:no-data>
                      Sin operaciones reales para esta operación.
                    </template>
                  </v-data-table>
                </v-tab-item>

                <v-tab-item>
                  <v-data-table :headers="headersParos" :items="parosRows" dense class="elevation-1 mt-3">
                    <template v-slot:no-data>
                      Sin paros para esta operación.
                    </template>
                  </v-data-table>
                </v-tab-item>

                <v-tab-item>
                  <v-data-table :headers="headersNoOk" :items="noOkRows" dense class="elevation-1 mt-3">
                    <template v-slot:no-data>
                      Sin registros No OK para esta operación.
                    </template>
                  </v-data-table>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>

          <v-card outlined v-else>
            <v-card-text class="grey--text text--darken-1">
              {{ 
              selectedODT ? 
              "Selecciona una operación para ver su detalle completo." : "Selecciona una ODT y luego una operación."
              }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";

export default {
  name: "InstanciaODTReport",

  data() {
    return {
      filtros: {
        IdsIntancias: [],
        FechaDeArranqueInicio: null,
        FechaDeArranqueFin: null,
      },
      nuevoIdInstancia: null,
      data: [],
      InformadorInstanciasLoading: false,
      selectedInstancia: null,
      selectedODT: null,
      selectedOperacion: null,
      detalleTab: 0,
      odtSearch: "",
    };
  },

  computed: {
    odtsSeleccionadas() {
      return this.findArrayByKeys(
        this.selectedInstancia,
        ["ODTs", "odTs", "odts", "OrdenesTrabajo", "ordenesTrabajo", "Ordenes", "ordenes"],
        ["odt", "orden", "trabajo"]
      );
    },

    odtsFiltradas() {
      const term = String(this.odtSearch || "")
        .trim()
        .toLowerCase();
      if (!term) return this.odtsSeleccionadas;

      return this.odtsSeleccionadas.filter((odt) => {
        const clave = String(this.pick(odt, ["Clave", "clave"], "")).toLowerCase();
        return clave.includes(term);
      });
    },

    operacionesSeleccionadas() {
      return this.findArrayByKeys(
        this.selectedODT,
        ["Operaciones", "operaciones", "operacionesAll"],
        ["operacion"]
      );
    },

    operacionesRealesRows() {
      return this.findArrayByKeys(
        this.selectedOperacion,
        ["OperacionesReales", "operacionesReales", "OperacionRealReportes", "operacionRealReportes"],
        ["operacionreal", "operacionesreales"]
      );
    },

    parosRows() {
      return this.findArrayByKeys(
        this.selectedOperacion,
        ["Paros", "paros"],
        ["paro"]
      );
    },

    noOkRows() {
      return this.findArrayByKeys(
        this.selectedOperacion,
        ["NoOk", "noOk", "NoOK", "noOK", "piezasNoOk", "piezasNOK"],
        ["nook", "nok", "scrap"]
      );
    },

    totalCantidadOperacionesReales() {
      return this.operacionesRealesRows.reduce((total, row) => {
        return total + this.toNumber(this.pick(row, ["Cantidad", "cantidad"], 0));
      }, 0);
    },

    totalCantidadNoOk() {
      return this.noOkRows.reduce((total, row) => {
        return total + this.toNumber(this.pick(row, ["CantidadReportada", "cantidadReportada"], 0));
      }, 0);
    },

    headersOperacionesReales() {
      return this.createHeaders(this.operacionesRealesRows);
    },

    headersParos() {
      return this.createHeaders(this.parosRows);
    },

    headersNoOk() {
      return this.createHeaders(this.noOkRows);
    },

    resumenOperacion() {
      if (!this.selectedOperacion) return [];

      return [
        { label: "Id Operacion", value: this.pick(this.selectedOperacion, ["IdOperacion", "idOperacion"], "-") },
        { label: "Id Trabajo Orden", value: this.pick(this.selectedOperacion, ["IdTrabajoOrden", "idTrabajoOrden"], "-") },
        { label: "Id Trabajo Orden Detalle", value: this.pick(this.selectedOperacion, ["IdTrabajoOrdenDetalle", "idTrabajoOrdenDetalle"], "-") },
        { label: "Id Receta", value: this.pick(this.selectedOperacion, ["IdReceta", "idReceta"], "-") },
        { label: "Id Paso", value: this.pick(this.selectedOperacion, ["IdPaso", "idPaso"], "-") },
        {
          label: "Nombre Articulo",
          value: this.pick(this.selectedOperacion, ["NombreArticulo", "nombreArticulo"], "-"),
        },
        {
          label: "Nombre Molde",
          value: this.pick(this.selectedOperacion, ["NombreMolde", "nombreMolde"], "-"),
        },
        {
          label: "Total Cantidad",
          value: this.formatNumber(this.totalCantidadOperacionesReales),
        },{
          label: "TC",
          value: this.pick(this.selectedOperacion, ["tc", "TC"], "-"),
        },{
          label: "A Reportar",
          value: this.pick(this.selectedOperacion, ["cantidad", "Cantidad"], "-"),
        },
        {
          label: "No ok",
          value: this.formatNumber(this.totalCantidadNoOk),
        },
      ];
    },
  },

  methods: {
    toNumber(value) {
      const number = Number(value);
      return Number.isFinite(number) ? number : 0;
    },

    formatNumber(value) {
      return this.toNumber(value).toLocaleString("es-MX", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },

    pick(obj, keys, fallback = null) {
      if (!obj || typeof obj !== "object") return fallback;
      for (const key of keys) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined && obj[key] !== null) {
          return obj[key];
        }
      }
      return fallback;
    },

    normalizeKey(key) {
      return String(key || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9]/g, "")
        .toLowerCase();
    },

    getArray(obj, keys) {
      const value = this.pick(obj, keys, []);
      return Array.isArray(value) ? value : [];
    },

    findArrayByKeys(obj, keys = [], hintTokens = []) {
      if (!obj || typeof obj !== "object") return [];

      const exact = this.getArray(obj, keys);
      if (exact.length) return exact;

      const entries = Object.entries(obj);
      const normalizedCandidates = keys.map((key) => this.normalizeKey(key));

      for (const [rawKey, value] of entries) {
        if (!Array.isArray(value)) continue;
        const normalized = this.normalizeKey(rawKey);
        if (normalizedCandidates.includes(normalized)) {
          return value;
        }
      }

      for (const [rawKey, value] of entries) {
        if (!Array.isArray(value)) continue;
        const normalized = this.normalizeKey(rawKey);
        if (hintTokens.some((token) => normalized.includes(this.normalizeKey(token)))) {
          return value;
        }
      }

      return [];
    },

    agregarIdInstancia() {
      const idInstancia = Number(this.nuevoIdInstancia);
      if (!Number.isInteger(idInstancia) || idInstancia <= 0) return;

      if (this.filtros.IdsIntancias.includes(idInstancia)) {
        this.nuevoIdInstancia = null;
        return;
      }

      this.filtros.IdsIntancias = [...this.filtros.IdsIntancias, idInstancia].sort((a, b) => a - b);
      this.nuevoIdInstancia = null;
    },

    eliminarIdInstancia(idInstancia) {
      this.filtros.IdsIntancias = this.filtros.IdsIntancias.filter((id) => id !== idInstancia);
    },

    countOdtByInstancia(instancia) {
      return this.findArrayByKeys(
        instancia,
        ["ODTs", "odTs", "odts", "OrdenesTrabajo", "ordenesTrabajo", "Ordenes", "ordenes"],
        ["odt", "orden", "trabajo"]
      ).length;
    },

    seleccionarInstancia(instancia) {
      this.selectedInstancia = instancia;
      this.selectedODT = null;
      this.selectedOperacion = null;
      this.detalleTab = 0;
      this.odtSearch = "";
    },

    seleccionarODT(odt) {
      this.selectedODT = odt;
      this.selectedOperacion = null;
      this.detalleTab = 0;
    },

    seleccionarOperacion(operacion) {
      this.selectedOperacion = operacion;
      this.detalleTab = 0;
    },

    createHeaders(rows) {
      if (!Array.isArray(rows) || !rows.length || typeof rows[0] !== "object") return [];
      return Object.keys(rows[0]).map((key) => ({
        text: this.humanizeKey(key),
        value: key,
      }));
    },

    humanizeKey(key) {
      return String(key || "")
        .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
        .replace(/_/g, " ")
        .replace(/\s+/g, " ")
        .trim()
        .replace(/^./, (char) => char.toUpperCase());
    },

    async InformadorInstanciaODT() {
      this.InformadorInstanciasLoading = true;

      try {
        this.data = [];
        this.selectedInstancia = null;
        this.selectedODT = null;
        this.selectedOperacion = null;
        this.detalleTab = 0;
        this.odtSearch = "";

        const response = await axios.get("ControlMaestro/InformadorInstanciaODT", {
          params: this.filtros,
          paramsSerializer: (params) => qs.stringify(params, { indices: false, skipNulls: true }),
        });

        this.data = Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        this.data = [];
        console.error("Error al obtener InformadorInstanciaODT:", error);
      } finally {
        this.InformadorInstanciasLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.instancia-card {
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.instancia-card--active {
  border: 1px solid #1976d2 !important;
  box-shadow: 0 0 0 1px rgba(25, 118, 210, 0.25);
}

.list-item-clickable {
  cursor: pointer;
}

.list-item-active {
  background: rgba(25, 118, 210, 0.12);
}
</style>

